import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css';
import '@trp-beacon-ui-kit/foundation/fonts/fonts.css';
import { reactBeaconButton } from '@trp-beacon-ui-kit/foundation/dist/react/beacon-button';
import { projectName } from 'services/globals';
import reactBeaconIconButton from "@trp-beacon-ui-kit/foundation/dist/react/beacon-icon-button";
import reactBeaconModal from "@trp-beacon-ui-kit/foundation/dist/react/beacon-modal";
import reactBeaconError from "@trp-beacon-ui-kit/foundation/dist/react/beacon-error";
import reactBeaconTableHeader from "@trp-beacon-ui-kit/foundation/dist/react/beacon-table-header";
import reactBeaconTableRecord from "@trp-beacon-ui-kit/foundation/dist/react/beacon-table-record";
import reactBeaconTableStub from "@trp-beacon-ui-kit/foundation/dist/react/beacon-table-stub";
import reactBeaconTable from "@trp-beacon-ui-kit/foundation/dist/react/beacon-table";
import reactBeaconTooltip from "@trp-beacon-ui-kit/foundation/dist/react/beacon-tooltip";
import reactBeaconAccordion from "@trp-beacon-ui-kit/foundation/dist/react/beacon-accordion";
import reactBeaconAccordionItem from "@trp-beacon-ui-kit/foundation/dist/react/beacon-accordion-item";
import reactBeaconPopover from "@trp-beacon-ui-kit/foundation/dist/react/beacon-popover";
import reactBeaconControl from "@trp-beacon-ui-kit/foundation/dist/react/beacon-control";
import reactBeaconNotification from "@trp-beacon-ui-kit/foundation/dist/react/beacon-notification";
import reactBeaconControlGroup from "@trp-beacon-ui-kit/foundation/dist/react/beacon-control-group";
import reactBeaconSegmentedControls from "@trp-beacon-ui-kit/foundation/dist/react/beacon-segmented-controls";
import reactBeaconSegmentedControl from "@trp-beacon-ui-kit/foundation/dist/react/beacon-segmented-control";
import reactBeaconTabs from "@trp-beacon-ui-kit/foundation/dist/react/beacon-tabs";
import reactBeaconTab from "@trp-beacon-ui-kit/foundation/dist/react/beacon-tab";
import reactBeaconTabPanel from "@trp-beacon-ui-kit/foundation/dist/react/beacon-tab-panel";
import reactBeaconPagination from "@trp-beacon-ui-kit/foundation/dist/react/beacon-pagination";
import reactBeaconMenu from "@trp-beacon-ui-kit/foundation/dist/react/beacon-menu";

// Prefix value to remove conflict with other component
const projectNamePrefix = `${projectName}`;

// Registered Beacon Components

export const AAMBeaconButton = reactBeaconButton(
  projectNamePrefix
);

export const AAMBeaconIconButton = reactBeaconIconButton(
  projectNamePrefix
);

export const AAMBeaconModal = reactBeaconModal(
  projectNamePrefix
);

export const AAMBeaconError = reactBeaconError(
  projectNamePrefix
);

export const AAMBeaconTableHeader = reactBeaconTableHeader(
  projectNamePrefix
);

export const AAMBeaconTableRecord = reactBeaconTableRecord(
  projectName
);

export const AAMBeaconTableStub = reactBeaconTableStub(
  projectName
);

export const AAMBeaconTable = reactBeaconTable(
  projectName
);

export const AAMBeaconTooltip = reactBeaconTooltip(
  projectName
);
export const AAMBeaconAccordion = reactBeaconAccordion(
  projectName
);
export const AAMBeaconAccordionItem = reactBeaconAccordionItem(
  projectName
);
export const AAMBeaconPopover = reactBeaconPopover(
  projectName
);

export const AAMBeaconMenu = reactBeaconMenu(
    projectName
);


export const AAMBeaconControl = reactBeaconControl(
  projectName
);

export const AAMBeaconNotification = reactBeaconNotification(
  projectName
);

export const AAMBeaconControlGroup = reactBeaconControlGroup(
  projectName
);

//new toggle component
export const AAMBeaconSegmentedControls = reactBeaconSegmentedControls(
  projectName
);

export const AAMBeaconSegmentedControl = reactBeaconSegmentedControl(
  projectName
);

export const AAMBeaconTabs = reactBeaconTabs(
    projectName
);

export const AAMBeaconTab = reactBeaconTab(
    projectName
);

export const AAMBeaconTabPanel = reactBeaconTabPanel(
    projectName
);

export const AAMBeaconPagination = reactBeaconPagination(
  projectName
)

const Registry = {
  AAMBeaconIconButton,
  projectNamePrefix,
  AAMBeaconButton,
  AAMBeaconModal,
  AAMBeaconError,
  AAMBeaconTableHeader,
  AAMBeaconTableRecord,
  AAMBeaconTableStub,
  AAMBeaconTable,
  AAMBeaconTooltip,
  AAMBeaconAccordion,
  AAMBeaconAccordionItem,
  AAMBeaconControl,
  AAMBeaconPopover,
  AAMBeaconNotification,
  AAMBeaconControlGroup,
  AAMBeaconSegmentedControls,
  AAMBeaconSegmentedControl,
  AAMBeaconTabs,
  AAMBeaconTab,
  AAMBeaconTabPanel,
  AAMBeaconPagination
};

export default Registry;
